import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface McpState {
  /** Advisor id currently open on the Tools tab (client UI context). */
  activeAdvisorIdForTools: string | null;
}

const initialState: McpState = {
  activeAdvisorIdForTools: null,
};

const mcpSlice = createSlice({
  name: 'mcp',
  initialState,
  reducers: {
    setActiveAdvisorIdForTools: (state, action: PayloadAction<string | null>) => {
      state.activeAdvisorIdForTools = action.payload;
    },
    clearMcpState: (state) => {
      state.activeAdvisorIdForTools = null;
    },
  },
});

export default mcpSlice.reducer;
export const { setActiveAdvisorIdForTools, clearMcpState } = mcpSlice.actions;
